import { useState } from 'react'
import PropTypes from 'prop-types'
import { IconUpload } from '@tabler/icons-react'
import { getFileName } from '../../utils/genericHelper'

export const File = ({ value, fileType, onChange, disabled = false }) => {
    const [myValue, setMyValue] = useState(value ?? '')
    const fileInputRef: any = useState(null)

    const handleFileUpload = async (e) => {
        if (!e.target.files) return

        if (e.target.files.length === 1) {
            const file = e.target.files[0]
            const { name } = file

            const reader = new FileReader()
            reader.onload = (evt) => {
                if (!evt?.target?.result) {
                    return
                }
                const { result } = evt.target

                const value = result + `,filename:${name}`

                setMyValue(value)
                onChange(value)
            }
            reader.readAsDataURL(file)
        } else if (e.target.files.length > 0) {
            const files = Array.from(e.target.files).map((file: any) => {
                const reader = new FileReader()
                const { name } = file

                return new Promise((resolve) => {
                    reader.onload = (evt) => {
                        if (!evt?.target?.result) {
                            return
                        }
                        const { result } = evt.target
                        const value = result + `,filename:${name}`
                        resolve(value)
                    }
                    reader.readAsDataURL(file)
                })
            })

            const res = await Promise.all(files)
            setMyValue(JSON.stringify(res))
            onChange(JSON.stringify(res))
        }
    }

    const handleButtonClick = () => {
        fileInputRef.current.click()
    }

    return (
        <div className="py-1 px-2 w-64">
            <span className={`italic text-gray-800 mb-4 block`}>
                {myValue ? getFileName(myValue) : 'Choose a file to upload'}
            </span>
            <label className={`flex items-center space-x-2 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
                <button
                    disabled={disabled}
                    onClick={handleButtonClick}
                    className={`w-full flex items-center px-4 py-2 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500`}
                >
                    <IconUpload className="h-5 w-5 mr-2" />
                    Upload File
                </button>
                <input 
                    type="file" 
                    multiple 
                    accept={fileType} 
                    hidden 
                    ref={(input) => fileInputRef.current = input}
                    onChange={(e) => handleFileUpload(e)} 
                />
            </label>
        </div>
    )
}

File.propTypes = {
    value: PropTypes.string,
    fileType: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
}